import React from "react";
import { useScrollProgress } from "../hooks/useScrollProgress";

// Coffee-themed scroll experience:
//  - a warm "coffee pour" progress bar across the top
//  - a corner cup that fills with coffee (with rising steam) as you scroll
//  Clicking the cup scrolls back to the top.
export default function CoffeeScroll() {
  const progress = useScrollProgress();
  const pct = Math.round(progress * 100);
  // fill height inside the 44px-tall cup body (leave ~4px lip)
  const fillH = Math.max(3, progress * 40);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <div className="coffee-bar" style={{ width: `${pct}%` }} />
      <div
        className="coffee-cup"
        onClick={toTop}
        role="button"
        aria-label={`Scrolled ${pct}%. Back to top`}
        title="Back to top"
      >
        <span className="cup-pct">{pct}% brewed</span>
        {progress > 0.04 && (
          <>
            <span className="cup-steam st1" />
            <span className="cup-steam st2" />
            <span className="cup-steam st3" />
          </>
        )}
        <div className="cup-body">
          <div className="coffee-liquid" style={{ height: `${fillH}px` }} />
        </div>
        <div className="cup-handle" />
        <div className="cup-saucer" />
      </div>
    </>
  );
}
